import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button, PasswordField } from '../../shared/ui/components';
import { AuthLayout } from './AuthLayout';

/** Destino del enlace de recuperación: elegir la contraseña nueva. El token es la prueba. */
export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  /** Enlace de bienvenida de una cuenta que registró la iglesia: la persona crea su primera contraseña. */
  const welcome = params.get('bienvenida') === '1';
  const title = welcome ? 'Crea tu contraseña' : 'Elegir contraseña nueva';
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const password = String(form.get('password'));
    if (password.length < 10) {
      setError('La contraseña debe tener al menos 10 caracteres.');
      return;
    }
    if (password !== String(form.get('confirm'))) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.post('/security/password-resets/confirm', { token, password });
      setDone(true);
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <AuthLayout title={title}>
        <Alert>El enlace está incompleto.</Alert>
        <p>
          <Link to="/olvide-contrasena">Pedir un enlace nuevo</Link>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={title}>
      {done ? (
        <>
          <Alert tone="success">
            {welcome ? '¡Bienvenido a KEORA! Tu cuenta está lista; ya puedes iniciar sesión con tu correo y esta contraseña.' : '¡Listo! Tu contraseña cambió. Por seguridad cerramos las sesiones que tenías abiertas.'}
          </Alert>
          <p>
            <Link to="/entrar" className="btn btn--primary btn--block">
              Iniciar sesión
            </Link>
          </p>
        </>
      ) : (
        <form className="form" onSubmit={onSubmit} noValidate>
          {welcome ? <p className="muted">Tu iglesia te registró en KEORA. Elige una contraseña para entrar.</p> : null}
          {error ? (
            <Alert>
              {error} {error.includes('enlace') ? <Link to="/olvide-contrasena">Pedir uno nuevo</Link> : null}
            </Alert>
          ) : null}
          <PasswordField
            label="Contraseña nueva"
            name="password"
            autoComplete="new-password"
            required
            minLength={10}
            hint="Mínimo 10 caracteres."
          />
          <PasswordField label="Repite la contraseña" name="confirm" autoComplete="new-password" required />
          <Button type="submit" busy={busy} className="btn--block">
            Guardar contraseña
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
